export default {
    button: {
        addCustomField: 'Benutzerdefiniertes feld hinzufügen',
        addField: 'Feld hinzufügen',
        add: 'Hinzufügen',
        addLink: 'Hinzufügen',
        copy: 'Kopieren',
        copyAsHTML: 'Als HTML kopieren',
        copyAsSelect: 'Signatur für Outlook kopieren',
        delete: 'Löschen',
        download: 'Herunterladen',
        importProject: 'Projekt importieren',
        load: 'Laden',
        newProject: 'Neues Projekt',
        showSetup: 'Setup-Anweisung anzeigen',
        uploadImage: 'Bild hochladen',
        viewSource: 'Quelle anzeigen',
        remove: 'Entfernen',
        close: 'Schließen',
        ok: 'OK',
        cancel: 'Kerze'
    },
    form: {
        label: 'Label',
        noLabel: 'Kein Label',
        type: 'Typ',
        value: 'Wert'
    },
    table: {
        name: 'Name',
        actions: 'Aktionen'
    },
    message: {
        warning: 'Warnung',
        deleteConfirm: 'Dadurch wird die Datei dauerhaft gelöscht. Fortfahren?'
    }
};
